import * as Types from '../../generated.types'

import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type PayrollPlatformsQueryVariables = Types.Exact<{ [key: string]: never }>

export type PayrollPlatformsQuery = {
  __typename?: 'Query'
  payrollPlatforms: Array<{
    __typename?: 'PayrollPlatform'
    id: number
    name: string
    code: string
    partnerExecutives: Array<{
      __typename?: 'PublicUser'
      id: number
      firstName?: string | null
      lastName?: string | null
    }>
  }>
}

export const PayrollPlatformsDocument = `
    query PayrollPlatforms {
  payrollPlatforms {
    id
    name
    code
    partnerExecutives {
      id
      firstName
      lastName
    }
  }
}
    `
export const usePayrollPlatformsQuery = <TData = PayrollPlatformsQuery, TError = Error>(
  variables?: PayrollPlatformsQueryVariables,
  options?: UseQueryOptions<PayrollPlatformsQuery, TError, TData>
) =>
  useQuery<PayrollPlatformsQuery, TError, TData>(
    variables === undefined ? ['PayrollPlatforms'] : ['PayrollPlatforms', variables],
    fetchGql<PayrollPlatformsQuery, PayrollPlatformsQueryVariables>(PayrollPlatformsDocument, variables),
    options
  )

usePayrollPlatformsQuery.getKey = (variables?: PayrollPlatformsQueryVariables) =>
  variables === undefined ? ['PayrollPlatforms'] : ['PayrollPlatforms', variables]
